module.exports = __webpack_public_path__ + "static/img/cdb1.87d39297.png";